import { AlignmentType, HeadingLevel, Paragraph, TextRun } from "docx";
import { drawBasicTable } from "../../write-sections/write_utils/drawTables_examples.js";
import { renderToStringAlt } from "../../../create-report/shared-components/renderToString.js";

const headers = [
    "Gene",
    "Transcript cDNA",
    "GT",
    "GQ",
    "DP",
    "REF count",
    "ALT count",
    "AAF",
];

const dataKeys = [
    "gene",
    "transcript_cDNA",
    "gt",
    "gq",
    "dp",
    "ref_count",
    "alt_count",
    "aaf",
];

function WriteVariantMetricsSection(sectionData) {
    let rows = sectionData && Array.isArray(sectionData) ? sectionData : [];
    
    return [
        new Paragraph({
            children: [
                new TextRun({
                    text: renderToStringAlt("Variant metrics"),
                    bold: true,
                    size: 22 
                })
            ],
        }),

        new Paragraph({
            text: "",
        }),
        drawBasicTable(rows, headers, dataKeys, renderToStringAlt("No data available")),
      
        new Paragraph({
            text: "",
        }),
    ];
}

export default WriteVariantMetricsSection;